//const vueAppMagenotApiUrl = process.env.VUE_APP_MAGENTO_API_URL;
const imageLibApiUrl = process.env.VUE_APP_IMAGELIB_API_URL;

import { wrapRequest } from './nav';
/*export const doFetchStoreLocationsList = wrapRequest(() => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
    };
    return fetch(`${vueAppMagenotApiUrl}/rest/V2/store-locator/search?criteria`, requestOptions)
});*/
export const doFetchStoreLocationsList = wrapRequest(() => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json'
        },
    };
    return fetch(`${imageLibApiUrl}/store_location`, requestOptions)
});

/*export const doFetchStoreLocationsList = async() => {
    let markers = [{
            name: "House of Aleida Greve",
            description1: "Placed:1",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: 52.3565, lng: 6.089625 }
        },
        {
            name: "Rio de Janeiro",
            description1: "Placed:1",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: 52.51195, lng: 6.091056 }
        },
        {
            name: "House of Johannes Cele",
            description1: "Placed:1",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: 52.23222, lng: 6.091728 }
        }
    ]

    return markers;
};*/
export const doFetchStoreLocationsByPlace = async(location) => {
    let markers = [{
            name: "House of Aleida Greve",
            description1: "By Current Location",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: location.lat, lng: location.lng }
        },
        {
            name: "Rio de Janeiro",
            description1: "Placed:1",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: 52.51195, lng: 6.091056 }
        }
    ]
    return markers;
};
export const doFetchStoresByPlaceWithRadius = async(location, radius) => {
    let markers = [{
            name: "House of Aleida Greve",
            description1: "Location with radius",
            description2: "Placed:2",
            description3: radius,
            date_build: "",
            position: { lat: location.lat, lng: location.lng }
        },
        {
            name: "Rio de Janeiro",
            description1: "Placed:1",
            description2: "Placed:2",
            description3: "Placed:3",
            date_build: "",
            position: { lat: 52.51195, lng: 6.091056 }
        }
    ]
    return markers;
};
/*export const doFetchStoreLocationsList = wrapRequest((token) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-type': 'application/json'
    , 'Authorization' : `Bearer ${token}`}
    };

    return fetch(`${process.env.VUE_APP_MAGENTO_API_URL}/stores/locations`, requestOptions)

});*/